export const STARTER_API = {
    STARTER_LOGIN:'/ws_an_login.php',
    FORGETPASS_API:'/ws_an_forgotpass.php',
    register_API:'/ws_an_register.php',
    hospitalregister_API:'/ws_an_hospital_register.php',
}
export const Admin_API = {
    addashboard:'/ws_an_admin_dash.php',
    Hospital_API:'/ws_an_admin_hospital_list.php',
    upload_API:'/ws_an_getuploads.php',
    Doc_API:'/ws_an_admin_doctors_list.php',
    Pantient_API:'/ws_an_admin_patient_list.php',
    Cases_API:'/ws_an_admin_cases_list.php',
    viewcases_API:'/ws_an_case_details.php',
    super_API:'/ws_an_admin_supervisor_reports.php',
    docreport_API:'/ws_an_admin_doctor_reports.php',
    Patien_API:'/ws_an_patient_cases.php',
    Apatien_API:'/ws_an_admin_patient_reports.php',
    country_API:'/ws_an_admin_country_list.php',
    sickness_API:'/ws_an_admin_sickness_list.php',
    speciality_API:'/ws_an_admin_specialty_list.php',
    language_API:'/ws_an_admin_language_list.php',
    officer_API:'/ws_an_admin_officers_list.php',
    region_API:'/ws_an_get_region.php',
    plan_API:'/ws_an_admin_plan_list.php',
    regionsss_API:'/ws_an_addregion.php',
    payments_API:'/ws_an_admin_payments.php',
    cat_API:'/ws_an_doctorCategory.php',
    



    //DocViwe_API:'ws_an_admin_doctors_list.php'

}
export const SUPRIVISOR_API = {
    sdashboard:'/ws_an_supervisor_dash.php',
    sdoctorget:'/ws_an_sup_doctors_list.php',
    speciality:'/ws_an_get_speciality.php',
    sickess_LIST:'/ws_an_sicknesslist.php',
    countrydata:'/ws_an_country.php',
    sassistant:'/ws_an_sup_assistant_list.php',
    addassistant:'/ws_an_add_assistant.php',
    verifyadd:'/ws_an_verify.php',
    accept_API:'/ws_an_accept_doctor_profile.php',
    slinkass:'/ws_an_link_assistant.php',
    sdoctordata:'/ws_an_get_hosp_profile.php',
    shospitaldata:'/ws_an_admin_doctors_list.php',
    sreports:'/ws_an_supervisor_doctor_reports.php',
    sactivities:'/ws_an_useractivities.php',
    assistantprofile_API:"/ws_an_get_assistant_profile.php",
    assistantProfilePhoto_API:'/ws_an_assprofilepic.php',
    sapplications:'/ws_an_supervisor_applications.php',
    sviewassistantsreports:'/ws_an_admin_doctor_reports.php',
    sviewapprovedapplications:'/ws_an_medicall_officer_app.php',
    sviewdocimage:'/ws_an_application_upload.php',
    scount:'/ws_an_supervisor_dash.php',
    getcountry:'/ws_an_country.php',
    getstate:'/ws_an_state.php',
    profilepic:'/ws_an_supervisorpic.php',
    hospitalimage:'/ws_an_updtaehsptllogo.php',
    sdoc:'/ws_an_getuploads.php',
    adddoc:'/ws_an_docupload.php',
    updateprofile:'/ws_an_updatehsptldata.php',
    updateProfile:'/ws_an_doctor_approver_profile.php',
    applyprofile:'/ws_an_applysup.php',
    assistantdetails:'/ws_an_get_assistant_profile.php',


}
export const MEOFFICER_API = {
    mapplications:'/ws_an_medicall_officer_app.php',
    doctordrop:'/ws_an_doctor.php',
    mprofile:'/ws_an_get_medical_officer_profile.php',
    ProfilePic_API:'/ws_an_consprofilepic.php',
    

}
export const DAPPROVER_API = {
    doctor_API:'/ws_an_doctor_approver.php',
    daview_API:'/ws_an_doctor_approver.php',
    daprofile_API:'/ws_an_get_doctor_approver_profile.php',
    daupdateprofile_API:'/ws_an_doctor_approver_profile.php',
    daprofilephoto_API:"/ws_an_consprofilepic.php",
    

}
export const DOCTOR_API ={
    doctordashboard_API:'/ws_an_doctor_dash.php',
    casesdoctor_API:'/ws_an_doctor_open_cases.php',
    reportsdata_API:'/ws_an_doctor_reports.php',
    shedule_API:'/ws_an_schedules.php',
    doctorprofile_API:'/prime_ws_an_doctor_profile.php',
    doctorupdateprofile_API:'/prime_ws_an_update_doctor_profile.php',
    applydoctor_API:'/prime_ws_an_apply_doctor_profile.php',
    speciality_API:'/ws_an_get_speciality.php',
    language_API:'/ws_an_language.php',
    doctorcasedetails_API:'/ws_an_case_details.php',
    invoice_API:'/ws_an_doctor_reports.php',
    casedocumentsuploads_API:'/ws_an_caseuploads.php',
    patientdata_API:'/ws_an_patient_cases.php',
    patienthis_API:'/ws_an_patient_history.php',
    notes_API:'/ws_an_newprogrness.php',
    DoctorProfile_API:'/ws_an_doctprofilepic.php',
    calender_APi:'/ws_an_schedules.php',
}

export const PATIENT_API ={
    patientcases_API:'/ws_an_patient_cases.php',
    gethosdata_API:'/ws_an_hospital.php',
    sickness_API:'/ws_an_sickness.php',
    aaapplication_API:'/ws_an_applications.php',
    casecreation_API:'/ws_an_corona_case_creation.php',
    searchdoctor_API:'/ws_an_search_doctor.php',
    family_API:'/ws_an_family.php',
    addfamily_API:'/ws_an_add_family.php',
    patientreports_API:'/ws_an_patient_reports.php',
    patientapplications_API:'/ws_an_patient_applications.php',
    state_API:'/ws_an_state.php',
    hospitalList_API:'/ws_an_hospitallist.php',
    doctordata_API:'/ws_an_doctor.php',
    opencases_APIAPP:'/ws_an_opencaseslist.php',
    applyapplication_API:'/ws_an_get_addapplication.php',
    regionsdata_API:'/ws_an_get_region.php',
    applyApplication_API:'/ws_an_get_addmediapplication.php',
    patientdashboard_API:'/ws_an_patient_dash.php',
    patientprofile_API:'/ws_an_getprofile.php',
    update_API:'/ws_an_updatepaprofile.php',
    applyprofile_API:'/ws_an_update_patient_profile.php',
    doctorDETAILS_API:'/ws_an_doctordetails.php',
    caseCount_API:'/ws_an_doctor_patient_case_count.php',
    detailsfee_API:'/ws_an_doctordetails.php',
    application_details_API:'/ws_an_application_data.php',
    patientProfile_API:'/ws_an_patientprofilepic.php',
    count_API:'/ws_an_primng_doctor_patient_case_count.php',
    createapplication_API:'/ws_an_application_add_case.php',
}




export const FNOFFICER_API = {
    fapplications:'/ws_an_finance_officer.php',
    // sactivities:'/ws_an_useractivities.php',
   fprofile:'/ws_an_get_finance_officer_profile.php',
   SviewdocImage:'/ws_an_offprofilepic.php',
  

}
export const CONOFFICER_API ={
    
    login_API:'/ws_an_consultancy_officer.php',
    cprofile_API:'/ws_an_get_consultancy_officer_profile.php',
    coprofilepic: '/ws_an_consprofilepic.php'
}